<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9" style="margin-top:-9;">
      <!-- Aviso de nueva versión -->
      <div class="new-version-banner">
        <div class="new-version-banner-msg">
          <i class="fas fa-rocket new-version-banner-icon"></i>
          <span>
            <strong>A partir del 2 de noviembre</strong> Cumplimiento de entregas solo estará disponible en la <strong>nueva consola</strong>.
            Empieza a usarla desde ahora para familiarizarte y que el día del cambio no te tome por sorpresa.
          </span>
        </div>
        <a
          href="https://consola-v2.canplast.net/docs-venta/cumplimiento"
          target="_blank"
          rel="noopener noreferrer"
          class="new-version-banner-link"
        >
          Ir a la nueva consola
          <i class="fas fa-external-link-alt ml-2"></i>
        </a>
      </div>

      <div
        class="card"
        style="overflow: hidden; border-radius: 16px;box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);"
      >
        <div v-if="rowsSelected" class="header-cta-container">
          <span>Entregas abiertas seleccionadas ({{ rowsSelected }})</span>
          <div
            style="display: flex; align-items: center; justify-content: flex-start; gap: 12px;"
          >
            <button
              v-if="rowsSelected > 1"
              @click="deselectAllRows"
              style="background-color: #E0E7FF; color: #525F7F;"
            >
              <i class="fas fa-times"></i> Eliminar selección
            </button>
            <button @click="handlePickingList">
              <i class="fas fa-arrow-down"></i> Obtener picking list
            </button>
          </div>
        </div>
        <div v-if="CEDIS && ready">
          <ag-grid-vue
            ref="agIncomingPayments"
            style="height: calc(80vh - 56px); margin: 0px !important;"
            class="ag-theme-alpine mb-5"
            v-bind="agIncomingPayments"
            tooltipShowDelay="0"
            @grid-ready="onGridReady"
            @selectionChanged="onSelectionChanged"
          />
        </div>

        <div v-else class="loader-cont">
          <div v-if="!CEDIS && ready">
            Solicita tu acceso a sistemas
          </div>
          <base-loader v-else></base-loader>
        </div>
      </div>
      <!-- TEMP para medir altura -->
      <div
        id="temp-measure-container"
        style="visibility: hidden; position: absolute; top: -9999px;"
      >
        <div
          v-for="(item, index) in itemsList"
          :key="'temp-' + index"
          class="item-list-structure temp-item"
        >
          <!-- mismo contenido que en el render principal -->
          ...
        </div>
      </div>
      <div
        id="document-container"
        v-show="onModal && itemsList.length > 0"
        class="modal-picking-list-container"
      >
        <div class="modal-picking-tools download-buttons">
          <button @click="openBlob(windowURL)" v-if="windowURL">
            <i class="fas fa-external-link-alt"></i> Abrir
          </button>

          <button
            @click="handlePDF(item.DocEntry)"
            v-for="(item, index) in selected"
            :key="index"
          >
            <i class="fas fa-arrow-down"></i> Descargar <b>{{ item.DocNum }}</b>
          </button>
        </div>
        <div ref="scrollContainer" class="pages-cont-pl">
          <div
            v-for="(group, i) in paginatedItems"
            :key="'page-' + i"
            class="modal-picking-list"
          >
            <div class="item-list-header">
              <img src="../../assets/logo_full.png" alt="cmp" />
              <div class="il-header-head">
                <hr class="header-line" />
                <span class="document-label-header">PICKING LIST</span>
                <hr class="header-line" />
                <span
                  >Fecha y hora de emisión:
                  <b>{{
                    new Date().toLocaleString("es-MX", { hour12: false })
                  }}</b></span
                >
                <span
                  >Usuario: <b>{{ user.displayName }}</b></span
                >
                <span
                  >CEDIS: <b>{{ CEDIS }}</b></span
                >
              </div>
            </div>
            <hr class="header-line" />
            <span class="pl-label" style="font-weight: 600;"
              >Entregas seleccionadas</span
            >

            <div class="items-list-container">
              <div
                class="item-list-structure"
                v-for="(item, index) in group"
                :key="'item-' + index"
              >
                <div class="item-list-st-header">
                  <div
                    class="item-list-small-col"
                    style="flex: 1; max-width: 110px;"
                  >
                    <span class="pl-label small-label">Item code</span>
                    <span class="pl-label">{{ item.itemCode }}</span>
                    <span class="pl-label text-primary" v-if="item.U_SubCode">{{
                      item.U_SubCode
                    }}</span>
                  </div>
                  <div class="item-list-small-col">
                    <span class="pl-label small-label">Cant. abierta</span>
                    <span class="pl-label">{{
                      Math.round(parseFloat(item.OpenQty) * 100) / 100
                    }}</span>
                  </div>

                  <div class="item-list-small-col">
                    <span class="pl-label small-label">Rest. almacen</span>
                    <span class="pl-label">{{
                      Math.round(parseFloat(item.OnHand) * 100) / 100
                    }}</span>
                  </div>

                  <div class="item-list-small-col" style="flex: 2">
                    <span class="pl-label small-label">Descripción</span>
                    <span class="pl-label">{{ item.Description }}</span>
                    <span
                      class="pl-label text-primary"
                      v-if="item.U_SubDescription"
                      >{{ item.U_SubDescription }}</span
                    >
                  </div>
                </div>
                <div
                  class="item-list-st-header"
                  style="justify-content: flex-start; border: none; padding-right: 16px; align-items: flex-start;"
                >
                  <div class="item-list-small-col" style="flex: 1">
                    <span class="pl-label small-label">Comentarios</span>
                    <span
                      v-for="(_i, index) in item.list"
                      :key="index"
                      class="pl-label"
                      >{{ _i.comments }}</span
                    >
                  </div>
                  <div class="item-list-small-col">
                    <span class="pl-label small-label">Doc Num</span>
                    <span
                      v-for="(_i, index) in item.list"
                      :key="index"
                      class="pl-label"
                      >{{ _i.docNum }}</span
                    >
                  </div>

                  <div class="item-list-small-col">
                    <span class="pl-label small-label">Card name</span>
                    <span
                      v-for="(_i, index) in item.list"
                      :key="index"
                      class="pl-label"
                      >{{ _i.CardName }}</span
                    >
                  </div>

                  <div class="item-list-small-col">
                    <span class="pl-label small-label">Quantity</span>
                    <span
                      v-for="(_i, index) in item.list"
                      :key="index"
                      class="pl-label"
                      >{{ _i.Quantity }}</span
                    >
                  </div>

                  <div class="item-list-small-col">
                    <span class="pl-label small-label"># Rollos</span>
                    <span
                      v-for="(_i, index) in item.list"
                      :key="index"
                      class="pl-label"
                      >{{
                        _i.U_Rolls
                          ? Math.round(parseFloat(_i.U_Rolls) * 100) / 100
                          : "-"
                      }}</span
                    >
                  </div>

                  <div class="item-list-small-col">
                    <span class="pl-label small-label">Ubicación</span>
                    <span
                      v-for="(_i, index) in item.list"
                      :key="index"
                      class="pl-label"
                      >{{
                        _i.BinCode && _i.BinQty
                          ? `${_i.BinCode}: ${_i.BinQty}`
                          : "-"
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loading" class="loading-icon">
          <base-loader></base-loader>
        </div>
        <div class="modal-picking-tools">
          <button
            @click="(onModal = false), (itemsList = []), (loading = false), (windowURL = null)"
            class="close-modal-button__"
          >
            <i class="fas fa-times" style="margin: 0;"></i>
          </button>

          <button @click="generarPDF" class="close-modal-button__">
            <i class="fas fa-print"></i>
          </button>

          <div class="separator-simple" />

          <button
            class="close-modal-button__"
            style="font-weight: 600; font-size: 12px;"
          >
            {{ `${currentPage}/${paginatedItems.length}` }}
          </button>

          <button @click="scrollTop" class="close-modal-button__">
            <i class="fas fa-arrow-up"></i>
          </button>

          <button @click="scrollBottom" class="close-modal-button__">
            <i class="fas fa-arrow-down" style="margin: 0;"></i>
          </button>

          <!-- <button @click="handlePDF" class="close-modal-button__">
            <i class="fas fa-arrow-right" style="margin: 0;"></i>
          </button> -->
        </div>
      </div>

      <!-- <base-loader v-if="itemsList.length == 0" text="Por favor espere."></base-loader> -->
    </div>
  </div>
</template>
<!--  @cell-clicked="onCellClickedIP" -->
<script>
/* eslint-disable vue/no-unused-components */
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";
import { AG_GRID_LOCALE_ES } from "@ag-grid-community/locale";
import Formats from "@/mixins/Formats";
import BaseLoader from "@/components/BaseLoader.vue";
import AgIcon from "@/components/AgGrid/AgIcon.vue";
import CancelIncPayment from "../IncomingPayments/CancelIncPayment.vue";
import AgGrid from "@/mixins/AgGrid";
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import { getAuth } from "firebase/auth";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  name: "TableIncPayments",
  mixins: [Formats, AgGrid],
  components: {
    AgGridVue,
    BaseLoader,
    AgIcon,
    CancelIncPayment,
    agDateInput: FilterDate,
  },
  data() {
    return {
      downloadingPDF: null,
      currentCancel: null,
      rowsSelected: null,
      onModal: false,
      user: null,
      CEDIS: null,
      ready: false,
      loading: false,
      gridApi: null,
      currentPage: 1,
      windowURL: null,
      DocEntry: null,
      paginatedItems: [],
      itemsList: [],
      modals: {
        cancel: false,
      },
      agIncomingPayments: {
        columnDefs: [
          {
            colId: "checkbox",
            checkboxSelection: true,
            // headerCheckboxSelection: true,
            maxWidth: 60,
            suppressHeaderMenuButton: true,
            sortable: false,
            resizable: false,
            filter: false,
          },
          {
            field: "DocNum",
            headerName: "# Entrega",
            sort: "desc",
            minWidth: 80,
            filter: "agTextColumnFilter",
          },
          {
            field: "CardName",
            headerName: "Cliente",
            sort: "desc",
            minWidth: 150,
            filter: "agTextColumnFilter",
          },
          {
            field: "DocDate",
            headerName: "Fecha",
            minWidth: 130,
            filter: "agDateColumnFilter",
            valueFormatter: ({ value }) => this.dateFormat(value),
          },
          {
            field: "U_WebDeliveryPrintedBy",
            headerName: "Impreso",
            sort: "desc",
            maxWidth: 80,
            tooltipValueGetter: (params) => {
              return `${params.value}`;
            },
            // filter: "agTextColumnFilter",
            cellRenderer: (params) => {
              if (params.value) {
                return '<i class="fas fa-check" style="color: #F5385A"></i>';
              } else {
                return "";
              }
            },
          },
          {
            field: "MetodoEnvio",
            headerName: "Método de envío",
            sort: "desc",
            minWidth: 80,
            filter: "agTextColumnFilter",
          },
          {
            field: "Surtido",
            headerName: "Surtido",
            filter: "agTextColumnFilter",
            minWidth: 100,
          },
          {
            field: "CondicionPago",
            headerName: "Condición de pago",
            sort: "desc",
            minWidth: 80,
            filter: "agTextColumnFilter",
          },
          {
            field: "Total",
            headerName: "Total",
            filter: "agTextColumnFilter",
            minWidth: 120,
            type: "numericColumn",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "AutorizacionPago",
            headerName: "Autorización",
            sort: "desc",
            minWidth: 80,
            filter: "agTextColumnFilter",
          },
          {
            field: "ComentariosInternos",
            headerName: "Comentarios",
            sort: "desc",
            minWidth: 180,
            filter: "agTextColumnFilter",
            valueFormatter: (params) => {
              if (!params.value) return "";
              return params.value
                .replace(/Basado en Ofertas de ventas \d+\.\s?/g, "")
                .replace(/Basado en Pedidos de cliente \d+\.\s?/g, "")
                .trim();
            },
          },
          {
            field: "U_CustomerCedis",
            headerName: "CEDIS Cliente",
            filter: "agTextColumnFilter",
            minWidth: 80,
          },
          {
            field: "WhsCode",
            headerName: "Almacén",
            filter: "agTextColumnFilter",
            minWidth: 80,
          },
          {
            field: "U_FulfillmentPrefer",
            headerName: "Preferencia de surtido",
            filter: "agTextColumnFilter",
            minWidth: 120,
          },
          {
            field: "Creador",
            headerName: "Creador",
            sort: "desc",
            minWidth: 120,
            filter: "agTextColumnFilter",
          },
          {
            field: "Programacion",
            headerName: "Programación",
            sort: "desc",
            minWidth: 80,
            filter: "agTextColumnFilter",
          },
          {
            field: "ProduccionRequerida",
            headerName: "Producción requerida",
            sort: "desc",
            minWidth: 80,
            filter: "agTextColumnFilter",
          },
          {
            field: "Referencia",
            headerName: "Referencia",
            filter: "agTextColumnFilter",
            minWidth: 100,
          },
          {
            field: "U_Project",
            headerName: "Proyecto",
            filter: "agTextColumnFilter",
            minWidth: 50,
          },
          // {
          //   field: "DocDueDate",
          //   headerName: "Fecha de vencimiento",
          //   minWidth: 130,
          //   filter: "agDateColumnFilter",
          //   valueFormatter: ({ value }) => this.dateFormat(value),
          // },
          // {
          //   field: "DocEntry",
          //   headerName: "DocEntry",
          //   sort: "desc",
          //   minWidth: 80,
          //   filter: "agTextColumnFilter",
          // },
        ],
        defaultColDef: {
          suppressHeaderMenuButton: true,
          sortable: true,
          resizable: true,
          cellDataType: false,
          filter: true,
          floatingFilter: true,
        },
        autoSizeStrategy: {
          type: "fitGridWidth",
          defaultMinWidth: 100,
        },
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        cacheBlockSize: 30,
        maxBlocksInCache: 10,
        rowModelType: "serverSide",
        loadingOverlayComponent: "BaseLoader",
        rowSelection: "multiple",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        rowMultiSelectWithClick: true,
        cacheQuickFilter: true,
        localeText: AG_GRID_LOCALE_ES,
        alwaysShowVerticalScroll: true,
      },
    };
  },
  created() {
    this.HANA_URL = process.env.VUE_APP_HANA_URL;
    this.BASE_URL = process.env.VUE_APP_BASE_URL;
    this.DATABASE = process.env.VUE_APP_DATABASE;
    this.user = getAuth().currentUser;
    this.ready = false;
    const CedisJson = {
      query: `SELECT "U_Cedis", "U_NAME"
	          FROM CANPLAST."OUSR" WHERE "E_Mail" = '${this.user.email}'`,
    };

    axios
      .post(`${this.HANA_URL}/api/hana/freedom`, CedisJson)
      .then((response) => {
        this.CEDIS = response.data[0].U_Cedis;
        this.ready = true;
      })
      .catch((err) => {
        console.error(err);
      });
  },
  watch: {
    itemsList() {
      this.$nextTick(() => this.splitItemsIntoPages());
    },
  },
  methods: {
    openBlob(url) {
      const win = window.open(url, "_blank");
      if (!win) {
        // Popup bloqueado → opción manual/fallback
        // 1) avisas con un toast/snackbar si quieres
        this.$message?.warning?.(
          "Tu navegador bloqueó la ventana emergente. Intenta permitir pop-ups para este sitio."
        );

        // 2) fallback opcional: abrir en misma pestaña
        // window.location.href = url;
      }
    },
    splitItemsIntoPages() {
      this.$nextTick(() => {
        const rawItems = [...document.querySelectorAll(".temp-item")];
        const maxHeight = 270;
        let pages = [];
        let currentPage = [];
        let currentHeight = 0;

        if (!rawItems) {
          return;
        }
        rawItems.forEach((el, idx) => {
          const height = el.offsetHeight;

          if (currentHeight + height > maxHeight) {
            pages.push(currentPage);
            currentPage = [];
            currentHeight = 0;
          }

          currentPage.push(this.itemsList[idx]);
          currentHeight += height;
        });

        if (currentPage.length > 0) {
          pages.push(currentPage);
        }

        this.paginatedItems = pages;
      });
    },
    onGridReady({ api }) {
      this.gridApi = api;
      api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
      api.setFilterModel({
        WhsCode: {
          filterType: "text",
          type: "contains",
          filter: this.CEDIS,
        },
      });
    },
    deselectAllRows() {
      if (this.gridApi) {
        this.gridApi.deselectAll();
      }
    },
    generatePickingListQuery(selectedRows) {
      if (!selectedRows.length) return "-- No hay filas seleccionadas";
      const docNums = selectedRows.map((row) => `'${row.DocNum}'`).join(", ");
      const query = `
        SELECT *
        FROM ${this.DATABASE}."FulfillmentOpenDelPickingList"
        WHERE "DocNum" IN (${docNums})
      `;

      return query.trim();
    },
    handlePickingList() {
      const query = this.generatePickingListQuery(this.selected);
      const queryBody = {
        query: query,
      };
      this.getPickingList(queryBody);
      // console.log(query);
    },
    onSelectionChanged({ api }) {
      this.selected = api.getSelectedRows();
      this.rowsSelected = this.selected.length;
    },

    getServerSideDatasource() {
      return {
        getRows: (params) => {
          const { filterModel, endRow, startRow, sortModel } = params.request;
          //SUBQUERY
          const subQuery = `
            SELECT *
            FROM ${this.DATABASE}."FulfillmentOpenDel"
          `;

          //FILTERS
          let filters = ``;
          const filterModelKeys = Object.keys(filterModel);
          if (filterModelKeys.length) {
            const all = filterModelKeys.reduce((acc, key) => {
              if (filterModel[key].operator) {
                const conditionsArray = filterModel[key].conditions.map(
                  (condition) => {
                    return this.formatCondition(condition, key);
                  }
                );
                const toPush =
                  "(" +
                  conditionsArray.join(" " + filterModel[key].operator + " ") +
                  ")";
                acc.push(toPush);
              } else {
                const condition = this.formatCondition(filterModel[key], key);
                if (condition) {
                  acc.push(condition);
                }
              }
              return acc;
            }, []);
            if (all.length) {
              filters += "WHERE " + all.join(" AND ");
            }
          }

          //PAGINATION
          const pageSize = endRow - startRow;
          const pagination = `LIMIT ${pageSize} OFFSET ${startRow}`;

          //SORTING
          let sorting;
          if (sortModel.length) {
            sorting = `ORDER BY "${
              sortModel[0].colId
            }" ${sortModel[0].sort.toUpperCase()}`;
            if (sortModel[0].colId !== "DocNum") {
              sorting += `, "DocNum" DESC`;
            }
          } else {
            sorting = `ORDER BY "DocNum" DESC`;
          }

          //JSON PAYLOADS
          const rowDataJson = {
            query: `
              SELECT *
              FROM (${subQuery})
              ${filters}
              ${sorting}
              ${pagination}
            `,
          };
          const totalsJson = {
            query: `
              SELECT COUNT(*) AS "rowCount"
              FROM (${subQuery})
              ${filters}
            `,
          };

          // console.log("🟦rowDataJson", rowDataJson.query);
          // console.log("🟦totalsJson", totalsJson.query);

          axios
            .all([
              axios.post(`${this.HANA_URL}/api/hana/freedom`, rowDataJson),
              axios.post(`${this.HANA_URL}/api/hana/freedom`, totalsJson),
            ])
            .then(
              axios.spread((rowDataRes, totalsRes) => {
                // console.log("🟪 DATA", rowDataRes.data);
                // console.log("🟪 TOTALS", totalsRes.data);
                params.success({
                  rowData: rowDataRes.data,
                  rowCount: totalsRes.data[0].rowCount,
                });
              })
            )
            .catch((err) => {
              console.error(err);
              params.fail();
            });
        },
      };
    },
    agruparPorItemCode(data) {
      const agrupado = {};

      data.forEach((item) => {
        const code = item.ItemCode;

        if (!agrupado[code]) {
          agrupado[code] = {
            itemCode: code,
            OpenQty: parseFloat(item.OpenQty),
            OnHand: parseFloat(item.OnHand),
            Description: item.Dscription,
            U_SubCode: item.U_SubCode,
            U_SubDescription: item.U_SubDescription,
            list: [],
          };
        } else {
          // Acumular OpenQty y OnHand si se repiten
          agrupado[code].OpenQty += parseFloat(item.OpenQty);
          // agrupado[code].OnHand += parseFloat(item.OnHand);
        }
        agrupado[code].list.push({
          docNum: item.DocNum,
          CardName: item.CardName,
          Quantity: parseFloat(item.Quantity),
          U_Rolls: item.U_Rolls,
          BinCode: item.BinCode,
          BinQty: item.BinQty,
          comments: item.ComentariosInternos
            ? item.ComentariosInternos.replace(
                /Basado en Ofertas de ventas \d+\.\s?/g,
                ""
              )
                .replace(/Basado en Pedidos de cliente \d+\.\s?/g, "")
                .trim()
            : null,
        });
      });

      // Convertir a arreglo final
      return Object.values(agrupado);
    },
    reloadTable() {
      this.gridApi.setGridOption(
        "serverSideDatasource",
        this.getServerSideDatasource()
      );
    },
    getPickingList(query) {
      axios
        .post(`${this.HANA_URL}/api/hana/freedom`, query)
        .then((response) => {
          console.log(response.data);
          this.itemsList = this.agruparPorItemCode(response.data);
          this.onModal = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    scrollBottom() {
      const container = this.$refs.scrollContainer;
      if (container && this.paginatedItems.length > 1) {
        container.scrollTop += 858; // Avanza 200px
        if (this.currentPage < this.paginatedItems.length) {
          this.currentPage = this.currentPage += 1;
        }
      }
    },
    scrollTop() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollTop -= 858; // Retrocede 200px
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage -= 1;
        }
      }
    },
    limpiarComentarios(comentarios) {
      return comentarios.map((comentario) =>
        comentario
          .replace(/Basado en Ofertas de ventas \d+\.\s?/g, "")
          .replace(/Basado en Pedidos de cliente \d+\.\s?/g, "")
          .trim()
      );
    },
    async updatePrinted() {
      this.loading = true;

      try {
        const patchPromises = this.selected.map((item) =>
          axios.patch(
            `${this.BASE_URL}/api/deliveries_notes?DocEntry=${item.DocEntry}`,
            { U_WebDeliveryPrintedBy: this.user.email }
          )
        );

        const responses = await Promise.all(patchPromises);
        console.log("PATCH completado:", responses);
      } catch (err) {
        console.error("Error al hacer PATCH:", err);
      } finally {
        // Limpieza final
        this.loading = false;
        // this.onModal = false;
        // this.itemsList = [];
        // this.deselectAllRows();
        this.reloadTable();
      }
    },
    handlePDF(DocEntry) {
      const json = {
        DocCode: "DLN20013",
        Pairs: {
          "DocKey@": DocEntry,
        },
      };
      axios
        .post(`${this.BASE_URL}/api/pdf_file`, json)
        .then((res) => {
          const base64String = res.data.base64.split(",")[1];
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          this.windowURL = blobUrl;
          window.open(this.windowURL, "_blank");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async generarPDF() {
      this.loading = true;
      const pages = document.querySelectorAll(".modal-picking-list"); // o '.page'
      const pdf = new jsPDF("p", "pt", "a4");
      const padding = 0;

      for (let i = 0; i < pages.length; i++) {
        const canvas = await html2canvas(pages[i], {
          scale: 2,
          useCORS: true,
        });

        const imgData = canvas.toDataURL("image/png");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth() - padding * 2;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, "PNG", padding, padding, pdfWidth, pdfHeight);
      }

      // pdf.save(`picking-list-${new Date().toISOString().split('T')[0]}.pdf`);
      const blobURL = pdf.output("bloburl");
      this.windowURL = blobURL;
      window.open(blobURL);

      this.updatePrinted();
    },
  },
};
</script>

<style lang="scss">
.ag-clickable-cell {
  cursor: pointer;
}
.ag-clickable-cell:hover {
  background: #e9ecef;
}

.header-cta-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  box-sizing: border-box;
  padding: 12px 24px;
  background-color: #f6f9fc;
  color: #8898aa;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #8898aa20;
}

.header-cta-container button {
  background-color: #5d72e4;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 16px;
  border-radius: 99px;
  border: none;
  // box-shadow: 0px 0px 8px rgba($color: #000000, $alpha: 0.1);
  transition: all 0.3s ease;
}

.header-cta-container button:hover {
  background-color: #5164d0;
}

.fa-arrow-down,
.fa-times {
  margin-right: 6px;
}

.modal-picking-list-container {
  position: fixed;
  z-index: 5;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-height: 100vh;
  overflow: auto;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: row-reverse;
  gap: 12px;
  box-sizing: border-box;
}

// .print-module-cont {
// width: 1000px;
// height: 100%;
//   max-height: 874px;
//   overflow: hidden;
//   background-color: #f6f9fc;
//   border-radius: 16px;
//   box-sizing: border-box;
//   display: flex;
//   align-items: flex-start;
//   justify-content: flex-start;
//   gap: 0px;
//   padding: 0px 12px 0px 0px;
//   padding-top: 0px;
// }

.separator-simple {
  align-self: stretch;
  height: 2px;
  background-color: #f6f9fc;
  margin: 12px 0px;
}

.modal-picking-list {
  width: 595px;
  min-width: 595px;
  height: 862px;
  min-height: 862px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 12px rgba($color: #000000, $alpha: 0.1);
  position: relative;
  box-sizing: border-box;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 12px;
}

.pages-cont-pl {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 16px;
  max-height: 100vh;
  // padding: 16px;
  padding-top: 36px;
  // padding: 36px 0px;
  box-sizing: border-box;
  overflow: auto;
  padding-bottom: 110px;
}

.pages-cont-pl {
  overflow: auto; /* o scroll si quieres forzarlo */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

.pages-cont-pl::-webkit-scrollbar {
  display: none; /* Chrome, Safari y Opera */
}

.items-list-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
}

.modal-picking-tools {
  // height: 842px;
  // width: 60px;
  border-radius: 99px;
  background-color: #fff;
  box-shadow: 0px 0px 12px rgba($color: #000000, $alpha: 0.1);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
  margin: 36px 0px;
  box-sizing: border-box;
}

.download-buttons {
  // height: 600px;
  // width: 200px;
  border-radius: 16px;
}

.download-buttons button {
  width: 100%;
  height: 30px;
  border-radius: 99px;
  border: none;
  background-color: #f9f9f9;
  padding: 4px 12px;
  font-weight: 400;
  transition: all 0.3s ease;
  font-size: 14px;
}

.download-buttons button:hover {
  background-color: #5d72e4;
  color: #fff;
}

.fa-arrow-down {
  margin-right: 6px;
}

.close-modal-button__ {
  background-color: #f9f9f9;
  height: 40px;
  width: 40px;
  border-radius: 99px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-modal-button__:hover {
  background-color: #5164d0;
  color: #fff;
}

.pl-label {
  font-size: 10px;
  font-weight: 400;
  font-weight: 600;
}

.small-label {
  font-size: 10px;
  opacity: 0.5;
  font-weight: 400;
}

.item-list-structure {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  // border-bottom: 1px solid #00000010;
  box-sizing: border-box;
  padding: 12px 0px;
  gap: 4px;
  font-size: 14px;
}

.item-list-structure span {
  flex: 1;
}

.item-list-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  align-self: stretch;
}

.item-list-header img {
  max-width: 150px;
}

.il-header-head {
  width: 250px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 4px;
  font-size: 10px;
}

.header-line {
  border-width: 2px;
  border-color: #932323;
  margin: 0px;
  width: 100%;
}

.document-label-header {
  align-self: stretch;
  text-align: center;
  font-weight: 800;
  font-size: 10px;
}

.item-list-st-header {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  gap: 12px;
  padding-bottom: 4px;
  border-bottom: 2px solid #00000010;
}

.item-list-small-col {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 0px;
}

.loader-cont {
  height: calc(80vh - 56px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-icon {
  position: absolute;
  top: 300px;
  background-color: #f9f9f980;
  backdrop-filter: blur(10px);
  border-radius: 16px;
  width: 400px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 50%;
  transform: translate(-50%);
  margin-left: 30px;
}

.ag-header-cell-sortable .ag-sort-order {
  display: none;
}

/* Aviso de nueva versión */
/* position: relative para pintarse sobre .header y no quedar debajo de la franja roja */
.new-version-banner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  box-sizing: border-box;
  min-height: 42px;
  margin-bottom: 14px;
  padding: 6px 18px;
  border-radius: 10px;
  border: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
  box-shadow: 0px 0px 12px rgba($color: #000000, $alpha: 0.06);
  color: #525f7f;
  font-size: 14px;
  line-height: 1.4;
}

.new-version-banner-msg {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.new-version-banner-msg strong {
  color: #32325d;
  margin-right: 4px;
}

.new-version-banner-icon {
  color: #f5365c;
  font-size: 18px;
}

.new-version-banner-link {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 8px 20px;
  border-radius: 99px;
  font-size: 13px;
  font-weight: 700;
  color: #fff !important;
  background: linear-gradient(87deg, #f5365c 0, #f55f36 200%);
  text-decoration: none;
  box-shadow: 0px 4px 12px rgba($color: #f5365c, $alpha: 0.3);
  transition: all 0.15s ease;
}

.new-version-banner-link:hover {
  transform: translateY(-1px);
  box-shadow: 0px 6px 18px rgba($color: #f5365c, $alpha: 0.4);
  text-decoration: none;
}
</style>
